module.exports = __webpack_public_path__ + "static/img/test2.a377249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test2.jpg
// module id = XSBM
// module chunks = 25